<template>
	<div class="d-flex flex-column h-100">
		<div v-if="subcontract.type === 'anulated' && hasData">
			<p class="text-right mb-0 caption font-weight-bold">
				{{ totalAmount.total_cost_uf_taxed | toThousandFilter(2) }} UF
			</p>
			<p class="text-right mb-0 caption font-weight-bold">
				${{ totalAmount.total_cost_clp_taxed | toThousandFilter }} CLP
			</p>
		</div>

		<div
			v-else
			class="d-flex flex-column flex-1"
			:class="{ 'justify-center': !hasSpent }"
		>
			<div v-if="hasData">
				<div v-if="!hasSpent">
					<p class="text-right mb-0 caption font-weight-bold">
						{{ totalAmount.total_cost_uf_taxed | toThousandFilter(2) }} UF
					</p>
					<p class="text-right mb-0 caption font-weight-bold">
						${{ totalAmount.total_cost_clp_taxed | toThousandFilter }} CLP
					</p>
				</div>

				<div v-else class="py-2" style="opacity: .5;">
					<p class="mb-1 text-left small-label">Monto Original:</p>
					<p class="text-right mb-0 small-value">
						{{ totalAmount.total_cost_uf_taxed | toThousandFilter(2) }} UF
					</p>
					<p class="text-right mb-0 small-value">
						${{ totalAmount.total_cost_clp_taxed | toThousandFilter }} CLP
					</p>

					<p class="mb-1 mt-2 text-left small-label">Monto Utilizado:</p>
					<p class="mb-0 small-value">
						{{ spentAmount.total_cost_uf | toThousandFilter(2) }} UF
					</p>
					<p class="mb-0 small-value">
						${{ spentAmount.total_cost_clp | toThousandFilter }} CLP
					</p>
				</div>
			</div>

			<v-divider v-if="hasSpent" class="my-1" />

			<div
				v-if="hasSpent && subcontract.type === 'active'"
				class="d-flex align-center justify-end"
			>
				<div class="text-right">
					<p class="mb-0 text-left small-label">Monto Disponible:</p>
					<p class="mb-0 font-weight-bold caption">
						{{ remainingAmount.total_cost_uf | toThousandFilter(2) }} UF
					</p>
					<p class="mb-0 font-weight-bold caption">
						${{ remainingAmount.total_cost_clp | toThousandFilter }} CLP
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { getParentItemTotalValueMultiWithTax, getParentItemTotalValueWithTax } from '@/helpers/tablecostHelpers.js'
export default {
	name: 'SubcontractorContractValueDisplay',
	props: {
		costsTable: {
			type: Object,
			required: true
		},
		costTableInfo: {
			type: Object,
			required: false,
			default: null
		},
		summarySubcontractInfo: {
			type: Object,
			required: true
		},
		taxRate: {
			type: Number,
			required: true
		},
		subcontract: {
			type: Object,
			required: true
		},
		ufValue: {
			type: Number,
			required: true
		},
		itemType: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			getParentItemTotalValueMultiWithTax,
			getParentItemTotalValueWithTax
		};
	},
	computed: {
		hasData() {
			return this.costTableInfo && this.summarySubcontractInfo
		},
		hasSpent() {
			return this.spentAmount?.total_cost_uf !== 0
		},
		annulatedSubcontracts(){
			if(this.costTableInfo){
				return this.summarySubcontractInfo.mainProjects.filter(mp => mp.annulated_subcontract)
			}
			return null
		},
		totalAmount(){
			if(this.itemType == 'stage'){
				return this.getParentItemTotalValueWithTax(this.costTableInfo.stage, this.costTableInfo?.project_table?.tax, this.ufValue)
			}
			else if(this.itemType == 'specialty'){
				return this.getParentItemTotalValueWithTax(this.costTableInfo.specialty, this.costTableInfo?.project_table?.tax, this.ufValue)
			}
			else if(this.itemType == 'reception'){
				return this.getParentItemTotalValueWithTax(this.costTableInfo?.project_table?.reception, this.summarySubcontractInfo.tax, this.ufValue)
			}
			return this.getParentItemTotalValueMultiWithTax([this.costTableInfo.project_table, this.costTableInfo.project_table?.surfaces], this.summarySubcontractInfo.tax, this.ufValue)
		},
		remainingAmount(){
			return {
				total_cost_uf: this.totalAmount.total_cost_uf_taxed - this.spentAmount.total_cost_uf,
				total_cost_clp: this.totalAmount.total_cost_clp_taxed - this.spentAmount.total_cost_clp
			}
		},
		spentAmount() {
			// Tax Included (cantidad pagada real)
			const payment_value = {
				total_cost_uf: 0,
				total_cost_clp: 0,
			}

			this.costsTable.payments.forEach(costsPayment => {
				if (!costsPayment || !Array.isArray(costsPayment.subcontract_payments)) return

				let project_type = this.subcontract.subcontract_info?.item_type

				const payment = this.getProjectPaymentTotalValue(
					costsPayment,
					project_type,
					this.subcontract.subcontract_info?.item_id
				)

				if (!Array.isArray(payment?.subpayments)) return

				payment.subpayments.forEach(subpayment => {
					if (!Array.isArray(subpayment.payment_order)) return

					subpayment.payment_order.forEach(order => {
						if (!order.payment_info) return

						const amountClp = Number(order.amount || 0)

						payment_value.total_cost_clp += amountClp
						payment_value.total_cost_uf += amountClp / Number(this.ufValue)
					})
				})
			})

			return payment_value
		},
	},
	mounted(){
	},
	methods: {
		getProjectPaymentTotalValue(costsPayment, paymentProjectType, typeItemId){
			return costsPayment.subcontract_payments.find(p =>
				p.item_type == paymentProjectType &&
				p.type_item_id == typeItemId
			) || null;
		},
	}
};
</script>

<style scoped>
.small-label {
	font-size: 9px;
	line-height: 9px;
}

.small-value {
	font-size: 10px;
	line-height: 10px;
	font-weight: bold;
}
</style>